// biome-ignore-all lint: legacy library
/* Respopnsebility: Make sure all browsers have get/set/removeProperty functions */
if (!CSSStyleDeclaration.prototype.getProperty) {
    CSSStyleDeclaration.prototype.getProperty = function (a) {
        return this.getAttribute(a);
    };
}
if (!CSSStyleDeclaration.prototype.setProperty) {
    CSSStyleDeclaration.prototype.setProperty = function (a, b) {
        return this.setAttribute(a, b);
    };
}
if (!CSSStyleDeclaration.prototype.removeProperty) {
    CSSStyleDeclaration.prototype.removeProperty = function (a) {
        return this.removeAttribute(a);
    };
}

if (!Element.prototype.closest) {
    Element.prototype.closest = function (selector) {
        var node = this;
        while (node && node.matches) {
            if (node.matches(selector)) {
                return node;
            }
            node = node.parentNode;
        }
        return null;
    };
}

(function () {
    if (typeof window.Element === 'undefined' || 'classList' in document.documentElement) return;

    var prototype = Array.prototype,
        push = prototype.push,
        splice = prototype.splice,
        join = prototype.join;

    function DOMTokenList(el) {
        this.el = el;
        // The className needs to be trimmed and split on whitespace
        // to retrieve a list of classes.
        var classes = el.className.replace(/^\s+|\s+$/g, '').split(/\s+/);
        for (var i = 0; i < classes.length; i++) {
            push.call(this, classes[i]);
        }
    }

    DOMTokenList.prototype = {
        add: function (token) {
            if (this.contains(token)) return;
            push.call(this, token);
            this.el.className = this.toString();
        },
        contains: function (token) {
            return this.el.className.indexOf(token) !== -1;
        },
        item: function (index) {
            return this[index] || null;
        },
        remove: function (token) {
            if (!this.contains(token)) return;
            for (var i = 0; i < this.length; i++) {
                if (this[i] === token) break;
            }
            splice.call(this, i, 1);
            this.el.className = this.toString();
        },
        toString: function () {
            return join.call(this, ' ');
        },
        toggle: function (token) {
            if (!this.contains(token)) {
                this.add(token);
            } else {
                this.remove(token);
            }

            return this.contains(token);
        },
    };

    window.DOMTokenList = DOMTokenList;

    function defineElementGetter(obj, prop, getter) {
        if (Object.defineProperty) {
            Object.defineProperty(obj, prop, {
                get: getter,
            });
        } else {
            obj.__defineGetter__(prop, getter);
        }
    }

    defineElementGetter(Element.prototype, 'classList', function () {
        return new DOMTokenList(this);
    });
})();

/*! matchMedia() polyfill - Test a CSS media type/query in JS. Authors & copyright (c) 2012: Scott Jehl, Paul Irish, Nicholas Zakas. Dual MIT/BSD license */

window.matchMedia =
    window.matchMedia ||
    (function (doc, undefined) {
        var docElem = doc.documentElement,
            refNode = docElem.firstElementChild || docElem.firstChild,
            // fakeBody required for <FF4 when executed in <head>
            fakeBody = doc.createElement('body'),
            div = doc.createElement('div');

        div.id = 'mq-test-1';
        div.style.cssText = 'position:absolute;top:-100em';
        fakeBody.style.background = 'none';
        fakeBody.appendChild(div);

        var mqRun = function (mq) {
                div.innerHTML = '&shy;<style media="' + mq + '"> #mq-test-1 { width: 42px; }</style>';
                docElem.insertBefore(fakeBody, refNode);
                bool = div.offsetWidth === 42;
                docElem.removeChild(fakeBody);

                return { matches: bool, media: mq };
            },
            getEmValue = function () {
                var ret,
                    body = docElem.body,
                    fakeUsed = false;

                div.style.cssText = 'position:absolute;font-size:1em;width:1em';

                if (!body) {
                    body = fakeUsed = doc.createElement('body');
                    body.style.background = 'none';
                }

                body.appendChild(div);

                docElem.insertBefore(body, docElem.firstChild);

                if (fakeUsed) {
                    docElem.removeChild(body);
                } else {
                    body.removeChild(div);
                }

                //also update eminpx before returning
                ret = eminpx = Number.parseFloat(div.offsetWidth);

                return ret;
            },
            //cached container for 1em value, populated the first time it's needed
            eminpx,
            // verify that we have support for a simple media query
            mqSupport = mqRun('(min-width: 0px)').matches;

        return function (mq) {
            if (mqSupport) {
                return mqRun(mq);
            }
            var min = mq.match(/\(min\-width[\s]*:[\s]*([\s]*[0-9\.]+)(px|em)[\s]*\)/) && Number.parseFloat(RegExp.$1) + (RegExp.$2 || ''),
                max = mq.match(/\(max\-width[\s]*:[\s]*([\s]*[0-9\.]+)(px|em)[\s]*\)/) && Number.parseFloat(RegExp.$1) + (RegExp.$2 || ''),
                minnull = min === null,
                maxnull = max === null,
                currWidth = doc.body.offsetWidth,
                em = 'em';

            if (min) {
                min = Number.parseFloat(min) * (min.indexOf(em) > -1 ? eminpx || getEmValue() : 1);
            }
            if (max) {
                max = Number.parseFloat(max) * (max.indexOf(em) > -1 ? eminpx || getEmValue() : 1);
            }

            bool = (!minnull || !maxnull) && (minnull || currWidth >= min) && (maxnull || currWidth <= max);

            return { matches: bool, media: mq };
        };
    })(document);

if (
    Object.defineProperty &&
    Object.getOwnPropertyDescriptor &&
    Object.getOwnPropertyDescriptor(Element.prototype, 'textContent') &&
    !Object.getOwnPropertyDescriptor(Element.prototype, 'textContent').get
)
    (function () {
        var innerText = Object.getOwnPropertyDescriptor(Element.prototype, 'innerText');
        Object.defineProperty(Element.prototype, 'textContent', {
            // It won't work if you just drop in innerText.get
            // and innerText.set or the whole descriptor.
            get: function () {
                return innerText.get.call(this);
            },
            set: function (x) {
                return innerText.set.call(this, x);
            },
        });
    })();

(function (ElementPrototype) {
    ElementPrototype.matches =
        ElementPrototype.matches ||
        ElementPrototype.matchesSelector ||
        ElementPrototype.webkitMatchesSelector ||
        ElementPrototype.mozMatchesSelector ||
        ElementPrototype.msMatchesSelector ||
        ElementPrototype.oMatchesSelector ||
        function (selector) {
            var nodes = (this.parentNode || this.document).querySelectorAll(selector),
                i = -1;

            while (nodes[++i] && nodes[i] !== this);

            return !!nodes[i];
        };
})(Element.prototype);

if (typeof Object.assign !== 'function') {
    Object.assign = function (target) {
        if (target == null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        target = Object(target);
        for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source != null) {
                for (var key in source) {
                    if (Object.prototype.hasOwnProperty.call(source, key)) {
                        target[key] = source[key];
                    }
                }
            }
        }
        return target;
    };
}
